import React from 'react';
import { CustomerSelector } from '@bingads-webui-react/customer-selector';

import { CustomMenuBase } from './custom-menu-base';

export class CustomMenu extends React.PureComponent {
  render() {
    return (
      <CustomMenuBase
        {...this.props}
        CustomerSelector={CustomerSelector}
      />
    );
  }
}
